import Swiper, { Navigation } from 'swiper';

Swiper.use([Navigation]);

const map = new WeakMap<HTMLElement, any>();

function initNavigation(container: HTMLElement | null) {
    if (container) container.innerHTML = `
        <button class="js-btn-prev button button__round button__round--gray slider-btn slider-btn--prev" aria-label="предыдущий слайд">
            <svg width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M10.3334 1.3335L6.00008 6.00016L1.66675 1.3335" stroke="#1F1F22" stroke-width="1.5" stroke-linecap="square"/>
            </svg>
        </button>
        <button class="js-btn-next button button__round button__round--gray slider-btn slider-btn--next" aria-label="следующий слайд">
            <svg width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M10.3334 1.3335L6.00008 6.00016L1.66675 1.3335" stroke="#1F1F22" stroke-width="1.5" stroke-linecap="square"/>
            </svg>
        </button>
    `;
}

function init(container: HTMLElement | Document = document) {
    const gallerySliders = Array.from(container.querySelectorAll<HTMLElement>('.js-persons-slider'));

    gallerySliders.forEach(slider => {
        const slides = slider.querySelectorAll<HTMLElement>('.swiper-slide');
        const navigation = container.querySelector<HTMLElement>('.js-navigation-managment');
        if (navigation && slides.length > 1) initNavigation(navigation);

        const swiper = new Swiper(slider, {
            slidesPerView: 1,
            spaceBetween: 10,
            navigation: {
                nextEl: '.js-btn-next',
                prevEl: '.js-btn-prev',
                disabledClass: 'is-disable',
            },
            breakpoints: {
                577: {
                    spaceBetween: 34,
                    slidesPerView: 2.5,
                },
                1025: {
                    spaceBetween: 16,
                    slidesPerView: 1,
                },
            }
        });

        map.set(slider, swiper);
    });
}

function destroy(container: HTMLElement | Document = document) {
    Array.from(container.querySelectorAll<HTMLElement>('.js-persons-slider')).forEach((el) => {
        const slider = map.get(el);

        if (slider) {
            slider.destroy();
            map.delete(el);
        }
    });
}

const _module = { init, destroy };

export default _module;
